import { useQuery, type ApolloError } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { StudentBookInfo } from './types';

const GET_STUDENT_BOOK_INFO = gql`
  query ($id: ID!, $entryYear: String!) {
    application(id: $id) {
      applicant {
        name {
          givenName
          surname
        }
      }
    }

    collectionTimeslots(entryYear: $entryYear) {
      closedNotes
      days {
        date
        allExpired
        slots {
          slotId
          slotName
          isAvailable
          isExpired
          meridiem
        }
      }
    }
  }
`;

type GetStudentBookInfo = {
  studentBookInfo: StudentBookInfo;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

const NA = 'N/A';
export const useGetStudentBookInfo = (
  id: string,
  entryYear: string,
): GetStudentBookInfo => {
  const { data, loading, error, refetch } = useQuery(GET_STUDENT_BOOK_INFO, {
    variables: {
      id,
      entryYear,
    },
    skip: !id,
  });

  const applicantName = data?.application?.applicant?.name ?? {};
  const studentBookInfo: StudentBookInfo = {
    applicantName: `${applicantName?.surname?.toUpperCase()} ${applicantName?.givenName}`,
    closedNotes: data?.collectionTimeslots?.closedNotes,
    cardCollectionSlots: (data?.collectionTimeslots?.days ?? []).map(
      (slot: any) => ({
        allExpired: slot?.allExpired ?? false,
        date: slot?.date ?? NA,
        slots: (slot?.slots ?? []).map((s: any) => ({
          slotId: s?.slotId ?? '',
          slotName: s?.slotName ?? NA,
          isAvailable: s?.isAvailable ?? false,
          isExpired: s?.isExpired ?? false,
          meridiem: s?.meridiem ?? NA,
        })),
      }),
    ),
  };

  return {
    studentBookInfo,
    loading,
    error,
    refetch,
  };
};
